import React from 'react';
import './Keyboard.css';
import { KeyboardViewModel } from './KeyboardViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

let viewModel = new KeyboardViewModel();
export function Keyboard() {
    let textBoxRef = React.useRef(null);

    SetupUIBindingForReactFunctionalComponent(viewModel);

    React.useEffect(() => {
        viewModel.initialize();
        viewModel.setFocus = () => {
            setTimeout(() => {
                if (textBoxRef && textBoxRef.current) {
                    textBoxRef.current.focus();
                }
            });
        };

        return () => {
            viewModel.destroy();
        };
    }, []);

    return <div className="flex-auto relative keyboard">
        {
            viewModel.isLoading ?
                <div>Loading...</div>
                : <>
                    {viewModel.uiLocation == 'main' ?
                        (
                            viewModel.keyboardCode ?
                                <div className="absolute fulfill flex-v content-area">
                                    <textarea className="flex-auto" ref={textBoxRef} disabled={viewModel.isBusy} value={viewModel.content} onChange={(e) => viewModel.sendContent(e.target.value)} onKeyDown={(e) => viewModel.onKeyDown(e)} onKeyUp={(e) => viewModel.onKeyUp(e)}></textarea>
                                    <div>
                                        <br />
                                        <button style={{ marginRight: '10px', width:'120px' }} onClick={() => viewModel.goToPreviousMessage()}>Back</button>
                                        <button onClick={() => viewModel.goToNextMessage()}>Forward</button>
                                    </div>
                                    <div>
                                        <br />
                                        Press <strong>Shift+Enter</strong> to let TypeFast input method type the content in the phone with what you just typed in your desktop.<br />
                                        Press <strong>Ctrl+Enter</strong> to let TypeFast input method type the content and press Enter in the phone with what you just typped in your desktop.
                                    </div>
                                </div>
                                : <div>
                                    <p>You don't have a keyboard code, yet. Please click <strong>"Keyboard Code"</strong> button to generate a keyboard code.</p>
                                    <p>You will need the keyboard code in the TypeFast input method UI of your phone to connect with your account.</p>
                                    <p>Then when you type in TypeFast web UI, the input method of your phone will get synced.</p>
                                </div>
                        )
                        : null}
                    {viewModel.uiLocation == 'code' ?
                        <>
                            {
                                viewModel.keyboardCode ?
                                    <div>
                                        Here is your keyboard code: <strong style={{ fontSize: '150%' }}>{viewModel.keyboardCode}</strong>
                                        <p>
                                            You can use this code to get your TypeFast input method connected.
                                Please go to your TypeFast input method in your phone, click the <strong>"Set Keyboard Code"</strong> button then input this code.
                                </p>
                                    </div>
                                    : null
                            }
                            <p><button onClick={() => viewModel.generateKeyboardCode()}>{viewModel.keyboardCode ? 'Generate Again' : 'Generate'}</button></p>
                            {
                                viewModel.keyboardCode ?
                                    <div>Note: if you re-generate the keyboard code, you need to go to TypeFast input method in your phone to set the keyboard code again.</div>
                                    : null
                            }
                            <p>{viewModel.keyboardCode}</p>
                            <div className="action">
                                <div>

                                </div>
                                <div className="right">
                                    <button onClick={() => viewModel.goBack()}>Go Back</button>
                                </div>
                            </div>
                        </>
                        : null}
                </>
        }
    </div>;
}
